const APP_POINTERS = {
  uuid: 0,
};

export const uuid = () => {
  APP_POINTERS.uuid += 1;
  let dt = new Date().getTime();
  const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return `${id}-${APP_POINTERS.uuid}`;
};

